export function initCookieConsentLink(Drupal) {
  "use strict";

  function openConsentModal() {
    if (typeof window.showConsentPreferencesPopup === "function") {
      window.showConsentPreferencesPopup();
    }
  }

  Drupal.behaviors.cookieConsentLink = {
    attach: function (context) {
      if (
        !context ||
        context !== document ||
        document.documentElement.dataset.cookieConsentDelegation === "true"
      ) {
        return;
      }

      document.documentElement.dataset.cookieConsentDelegation = "true";

      document.addEventListener("click", function (event) {
        var link = event.target.closest ? event.target.closest("a") : null;
        if (!link) {
          return;
        }

        var href = link.getAttribute("href") || "";
        if (href.indexOf("open_cookie_preferences=1") === -1) {
          return;
        }

        event.preventDefault();
        openConsentModal();
      });
    },
  };
}
